var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Small } from "syf-component-library/ui/typography";
import i18n from "../../../strings/i18n";
import { AutopayButtonWrapper, AutopayStatus } from "./AutopayButton.styles";
var AutopayButton = function (_a) {
    var _b = _a.autopayEnrollment, autopayEnrollment = _b === void 0 ? false : _b, isViewAccountDisabled = _a.isViewAccountDisabled, handleAutopayClick = _a.handleAutopayClick;
    return (_jsxs(AutopayButtonWrapper, __assign({ buttonType: "text", "data-analytics": "clicktrackingevent", "data-object": "button", "data-reason": "autopay", "data-test": "autopay-text", "data-type": "autopay", disabled: isViewAccountDisabled, onClick: handleAutopayClick }, { children: [_jsx(Small, __assign({ isInline: true }, { children: i18n({ autopay: "text" }) })), "\u00A0", _jsx(AutopayStatus, __assign({ isInline: true, weight: "bold" }, { children: autopayEnrollment ? (_jsx(_Fragment, { children: i18n({ autopay: "on" }) })) : (_jsx(_Fragment, { children: i18n({ autopay: "off" }) })) }))] })));
};
export default AutopayButton;
//# sourceMappingURL=AutopayButton.js.map